// extracted by mini-css-extract-plugin
export default {"body":"FiltersBottomDrawer_body__cp+Xc","sortButton":"FiltersBottomDrawer_sortButton__uBNf2","sortButtons":"FiltersBottomDrawer_sortButtons__B+-YE"};